import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { Button } from '@mui/material';
import DashVendaMesDialog from '../DashVendaMesDialog';
import DashVendaMesClienteDialog from '../DashVendaMesClienteDialog';
import { calcularTamanhoFonte } from '../../../utils/fontSize';
import api from '../../../services/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(valor);
};

const Dashboard = ({ isPaused, setIsPaused }) => {
    const [dados, setDados] = useState([]);
    const [dadosDialog, setDadosDialog] = useState([]);
    const [dadosDialogCliente, setDadosDialogCliente] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const [modalClienteAberto, setmodalClienteAberto] = useState(false);
    const [representanteSelecionado, setRepresentanteSelecionado] = useState('');
    const [supervisorSelecionado, setSupervisorSelecionado] = useState('');

    useEffect(() => {
        api.get('/vendames_dash')
            .then(response => setDados(response.data))
            .catch(error => console.error('Erro ao carregar os dados:', error));
    }, []);

    useEffect(() => {
        api.get('/vendames_detalhado')
            .then(response => setDadosDialog(response.data))
            .catch(error => console.error('Erro ao carregar os dados:', error));
    }, []);

    useEffect(() => {
        api.get('/vendames_detalhado_cliente')
            .then(response => setDadosDialogCliente(response.data))
            .catch(error => console.error('Erro ao carregar os dados:', error));
    }, []);

    function abrirModal() {
        setModalAberto(true);
        setIsPaused(true);
    }

    function abrirModalCliente() {
        setmodalClienteAberto(true);
        setIsPaused(true);
    }

    function fecharModal() {
        setModalAberto(false);
        // setIsPaused(false);
    }

    function fecharModalCliente() {
        setmodalClienteAberto(false);
        // setIsPaused(false);
    }

    const metaDoMes = Number(dados.MetaMes) || 0;
    const metaParcial = Number(dados.MetaParcial) || 0;
    const totalVendas = Number(dados.VlrPedido) || 0;

    const chartData = {
        labels: ['VENDAS'],
        datasets: [
            {
                label: 'META DO MÊS (R$)',
                data: [metaDoMes],
                backgroundColor: ['#1976d2']
            },
            {
                label: 'META PARCIAL (R$)',
                data: [metaParcial],
                backgroundColor: ['#8A3CE4FF']
            },
            {
                label: 'TOTAL DE VENDAS (R$)',
                data: [totalVendas],
                backgroundColor: ['#26a69a']
            },
        ]
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('label')
                    }
                }
            },
            datalabels: {
                anchor: 'end',
                align: 'bottom',
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: calcularTamanhoFonte('datalabel')
                },
                formatter: (value) => formatarValor(value)
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('scales')
                    }
                },
                grid: { color: '#444' }
            },
            y: {
                ticks: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('scales')
                    }
                },
                grid: { color: '#444' }
            }
        }
    };

    return (
        <div>
            <h1>Vendas do Mês</h1>
            <div style={{ height: '80vh', overflow: 'hidden', padding: '20px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Bar data={chartData} options={chartOptions} sx={{ mb: 2 }} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                <Button variant="contained" color="success" onClick={abrirModal} style={{ marginTop: '20px' }}>
                    📊 Detalhes Representante
                </Button>

                <Button variant="contained" color="success" onClick={abrirModalCliente} style={{ marginTop: '20px' }}>
                    📊 Detalhes Cliente
                </Button>
            </div>

            <DashVendaMesDialog
                open={modalAberto}
                onClose={fecharModal}
                dados={dadosDialog}
                supervisorSelecionado={supervisorSelecionado}
                setSupervisorSelecionado={setSupervisorSelecionado}
                representanteSelecionado={representanteSelecionado}
                setRepresentanteSelecionado={setRepresentanteSelecionado}
            />

            <DashVendaMesClienteDialog
                open={modalClienteAberto}
                onClose={fecharModalCliente}
                dados={dadosDialogCliente}
                supervisorSelecionado={supervisorSelecionado}
                setSupervisorSelecionado={setSupervisorSelecionado}
                representanteSelecionado={representanteSelecionado}
                setRepresentanteSelecionado={setRepresentanteSelecionado}
            />
        </div >
    );
};

export default Dashboard;
